import React, { useEffect, useState } from "react";
import { getDeliveredOrdersApi, exportOrder } from "../../api/orders";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DateRangeFilter from "../reports/DateRangeFilter";
import ExportCsvButton from "../../common/ExportCsvButton";
import FullPageLoader from "../../common/FullPageLoader";
import EmptyState from "../../common/EmptyState";

const DeliveredOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  const [dateFilters, setDateFilters] = useState({ from: "", to: "" });

  const [loading, setLoading] = useState(false);

  const fetchDeliveredOrders = async (from = "", to = "") => {
    try {
      setLoading(true);
      const response = await getDeliveredOrdersApi({
        fromDate: from,
        toDate: to,
      });
      const orderList = response?.data || response?.orders || [];
      let filteredOrders = orderList;
      // Date range filter
      if (from && to) {
        const startDate = new Date(`${from}T00:00:00`);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(`${to}T00:00:00`);
        endDate.setHours(23, 59, 59, 999);
        filteredOrders = orderList.filter((order) => {
          const orderDate = new Date(order.createdAt);
          return orderDate >= startDate && orderDate <= endDate;
        });
      }
      setOrders(filteredOrders);
    } catch (error) {
      console.error(error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDeliveredOrders(dateFilters.from, dateFilters.to);
  }, [dateFilters.from, dateFilters.to]);

  const handleExportOrder = async () => {
    try {
      const response = await exportOrder({
        fromDate: dateFilters.from,
        toDate: dateFilters.to,
      });
      const blob = new Blob([response.data], {
        type: "text/csv",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "orders.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    }
  };
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "-";
    const day = ("0" + d.getDate()).slice(-2);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };
  return (
    <div className="container-fluid p-4">
      {loading && <FullPageLoader text="Loading delivered orders..." />}
      {!loading && orders.length === 0 ? (
        <div className="card p-3">
          <EmptyState />
        </div>
      ) : (
        <div className="card p-3">
          <div className="d-flex align-items-end justify-content-end gap-2 pb-3 flex-wrap">
            <DateRangeFilter
              filters={dateFilters}
              onChange={(filters) =>
                setDateFilters({ from: filters.from || "", to: filters.to || "" })
              }
            />
            <div className="col-auto">
              <ExportCsvButton className="text-nowrap" onClick={handleExportOrder} />
            </div>
          </div>

          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th className="text-dark fw-bold"> # </th>
                <th className="text-dark fw-bold">Order ID</th>
                <th className="text-dark fw-bold">Order Date</th>
                <th className="text-dark fw-bold">Dispatch Date</th>
                <th className="text-dark fw-bold">Customer Name</th>
                <th className="text-dark fw-bold">Product Name</th>
                <th className="text-dark fw-bold">Variation</th>
                <th className="text-dark fw-bold">Total Amount</th>
                <th className="text-dark fw-bold                            ````````````">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : (
                orders.map((order, index) => (
                  <tr key={order._id}>
                    <td>{index + 1}</td>
                    <td> {order.orderId} </td>
                    <td>{formatDate(order.createdAt)}</td>
                    <td>{formatDate(order.shipment?.dispatch_date)} </td>
                    <td>{order.address?.fullName}</td>
                    <td> {order.items?.[0]?.name} </td>
                    <td>
                      {order.items?.[0]?.variationName ||
                        order.items?.[0]?.selections?.variationId?.name ||
                        "N/A"}
                    </td>
                    <td>₹{order.total} </td>
                    <td className="text-center">
                      <button
                        className="btn btn-sm np-table-action-btn"
                        onClick={() =>
                          navigate("/orders/view", {
                            state: {
                              orderId: order._id,
                              fromDeliveredOrders: true,
                            },
                          })
                        }
                      >
                        <FaEye />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DeliveredOrders;
